






import { Vue, Component, Prop } from "vue-property-decorator"

@Component
export default class TableItemIsEnabled extends Vue {
  @Prop()
  private isEnabled!: boolean
  @Prop({ default: "有効" })
  private truthy?: string
  @Prop({ default: "無効" })
  private falsy?: string
}
